"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslate = exports["default"] = void 0;
var _enUS = _interopRequireDefault(require("./en-US"));
/**
 * A custom hook that provides translation functionality
 * Though we do not support any other languages yet, this hook is designed to be extensible
 * for future localization needs and to provide a consistent API for using
 * text resources (en-US.json) throughout the UI apps.
 * @returns {Object} An object containing the translate function
 */
var useTranslate = exports.useTranslate = function useTranslate() {
  // Initialize with en-US translations
  /**
   * Looks up a translation key in the translations object
   * @param {string} key - The translation key to look up
   * @returns {string} The translated text or the key itself if not found
   */
  var translate = function translate(key) {
    return key in _enUS["default"] ? _enUS["default"][key] : key;
  };
  return {
    translate: translate
  };
};
var _default = exports["default"] = useTranslate;